import { render, staticRenderFns } from "./abnormal-detail.vue?vue&type=template&id=2dec906d"
import script from "./abnormal-detail.vue?vue&type=script&lang=js"
export * from "./abnormal-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports